import { Libraries, useJsApiLoader } from '@react-google-maps/api';

const libraries: Libraries = ['geometry', 'places'];

const LOADER_CONFIG = {
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY || '',
  language: 'en',
  libraries,
};

export const useGoogleMaps = () => {
  return useJsApiLoader(LOADER_CONFIG);
};
